import { render, staticRenderFns } from "./VideoBoostAutoOrder.vue?vue&type=template&id=487797ba&scoped=true&"
import script from "./VideoBoostAutoOrder.vue?vue&type=script&lang=js&"
export * from "./VideoBoostAutoOrder.vue?vue&type=script&lang=js&"
import style0 from "./VideoBoostAutoOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VideoBoostAutoOrder.vue?vue&type=style&index=1&id=487797ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487797ba",
  null
  
)

export default component.exports